import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { MultiSelect } from 'react-multi-select-component';
import { useManualState } from './Provider';
import * as action from './store/Document.action';
import { createOptions } from '../../Components/helper';
import { CloseIcon, TickIcon } from '../../bombiix-icon';

function ShareDocumentModal({ onOpen, toggle }) {
  const { state, setState } = useManualState(); // Assuming this manages your component state
  const { t } = useTranslation('common');

  const dispatch = useDispatch();
  const reducer = useSelector((reducerstate) => reducerstate);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [validationError, setValidationError] = useState('');

  const {
    BomLibraryDetails: { ReferenceSupplier },
  } = reducer;

  const [formData, setFormData] = useState({
    folderName: '',
    shareOption: 'allSuppliers', // Default to all suppliers
    selectedSupplier: null, // Holds the selected supplier ID
  });

  useEffect(() => {
    if (ReferenceSupplier) {
      setSupplierOptions(createOptions(ReferenceSupplier, 'name', '_id'));
    }
  }, [ReferenceSupplier]);

  const handleInputChange = (e, name = null) => {
    const { name: targetName, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name || targetName]: value,
    }));
  };

  const handleSubmit = async () => {
    if (formData.shareOption === 'specificSupplier' && (!formData.selectedSupplier || formData.selectedSupplier.length === 0)) {
      setValidationError('Please select Supplier');
      return;
    }
    setValidationError('');
    const data = {
      userIds: formData?.shareOption === 'specificSupplier' ? formData?.selectedSupplier.map((re) => re?._id) : supplierOptions?.map((re) => re?._id),
    };

    setState((prev) => ({
      ...prev,
      loading: true,
    }));

    const res = await dispatch(action.shareDocumentWithSupplier(state?.selectedDocumentId?._id, data, t));

    if (res) {
      setState((prev) => ({
        ...prev,
        isOpenShareDocPopup: false,
        loading: false,
      }));
    }
  };

  return (
    <Modal
      show={onOpen}
      size="md"
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      className="common-custom-modal modal-medium"
      onHide={toggle}
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter"> {t('MANUAL_DOCUMENTS.SHARE_DOCUMENT')}</Modal.Title>
        <CloseIcon size={28} onClick={toggle} className="cursor-pointer" />
      </Modal.Header>
      <Modal.Body>
        <div className="modal-inner-data">
          {/* Radio Buttons for Sharing Options */}
          <div className="form-group">
            <div className="d-flex">
              <p className="f-16 text-bold">{t('MANUAL_DOCUMENTS.FILE_NAME')}:</p> <span className="ml-8 f-16">{state?.selectedDocumentId?.fileName}</span>
            </div>
            <div>
              <p className="custom-radio mb-16 mr-3">
                <input
                  type="radio"
                  id="detailed_yes"
                  value="allSuppliers"
                  name="shareOption"
                  checked={formData?.shareOption === 'allSuppliers'}
                  onChange={handleInputChange}
                />
                <label className="m-0 text-black" htmlFor="detailed_yes">
                  {t('MANUAL_DOCUMENTS.ASSIGN_TO_ALL_SUPPLIER')}{' '}
                </label>
              </p>
              <p className="custom-radio mb-0 mr-3">
                <input
                  type="radio"
                  id="detailed_no"
                  value="specificSupplier"
                  name="shareOption"
                  checked={formData?.shareOption === 'specificSupplier'}
                  onChange={handleInputChange}
                />
                <label className="m-0 text-black" htmlFor="detailed_no">
                  {t('MANUAL_DOCUMENTS.ASSIGN_TO_SPECIFIC_SUPPLIER')}
                </label>
              </p>
            </div>
          </div>

          {/* Dropdown for Specific Supplier (Conditional Rendering) */}
          {formData?.shareOption === 'specificSupplier' && (
            <div className="form-group">
              <div className="common-react-select mb-0">
                <p className="field-name">{t('DPP.BASIC_DETAILS.SUPPLIER')}</p>
                <MultiSelect
                  options={supplierOptions}
                  className="product-custom-multiselect common-new-multiselect w-100"
                  value={formData?.selectedSupplier || []}
                  labelledBy={t('DPP.BASIC_DETAILS.SELECT_SUPPLIER')}
                  overrideStrings={{
                    selectSomeItems: t('DPP.BASIC_DETAILS.SELECT_SUPPLIER'),
                    search: t('DPP.BASIC_DETAILS.SEARCH_SUPPLIER'),
                  }}
                  onChange={(selected) => handleInputChange({ target: { value: selected } }, 'selectedSupplier')}
                />
              </div>
              {validationError && <div className="text-danger mt-2">{validationError}</div>}
            </div>
          )}
        </div>

        <div className="common-model-footer">
          <button aria-label="save" onClick={() => handleSubmit()} type="button" className="btn p-0">
            <TickIcon size={28} />
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ShareDocumentModal;
